module.exports = __webpack_public_path__ + "static/media/hint.43c42c51.ogg";